import { computed, type ComputedRef } from 'vue';
import type { TFolder } from '@/_core/entities/report/models/types';
import { DEFAULT_FOLDER_NAMES } from '@/_core/entities/report/models/consts';

export function useFalsePositiveFolder(folders: ComputedRef<TFolder[]>) {
  return computed(
    () => folders.value.find((f) => f.name === DEFAULT_FOLDER_NAMES.falsePositives) ?? null
  );
}
